// import {
//   incidentLevels,
//   trainingLevels,
//   workPermitLevels,
// } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/WorkPermitProcesses/permissionLevels";

export const CONSTANT = {
  add: "Add",
  edit: "Edit",
  approve: "Approve",
  editAfterApprove: "Edit After Approve",
  view: "View",
  delete: "Delete",
  download: "Download",
  dashboard: "Dashboard",
};

// export const TRAINING_CONSTANT = {};
// export const INCIDENT_CONSTANT = {};
// export const WORKPERMIT_CONSTANT = {};

// Object.keys(trainingLevels).forEach((levelKey) => {
//   TRAINING_CONSTANT[trainingLevels[levelKey].key] =
//     trainingLevels[levelKey].title;
// });

// Object.keys(incidentLevels).forEach((levelKey) => {
//   INCIDENT_CONSTANT[incidentLevels[levelKey].key] =
//     incidentLevels[levelKey].title;
// });

// Object.keys(workPermitLevels).forEach((levelKey) => {
//   WORKPERMIT_CONSTANT[workPermitLevels[levelKey].key] =
//     workPermitLevels[levelKey].title;
// });

export const USERROLE = [
  { name: "IED Super Admin", value: 1 },
  { name: "Global Admin", value: 2 },
  { name: "Project Admin", value: 3 },
  // { name: "Approver", value: 4 },
  { name: "User", value: 5 },
  { name: "IED Support Staff", value: 6 },
  { name: "IED User As Client User", value: 7 },
];
export const SITETYPE = [
  { name: "HO", value: 1 },
  { name: "RO", value: 2 },
  { name: "Mine Manager", value: 3 },
];
